import React from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  icon: string;
  message: string;
  title?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  icon, 
  message, 
  title,
  actionLabel,
  onAction,
  className = '' 
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-icon">{icon}</div>
      {title && <h3>{title}</h3>}
      <p>{message}</p>
      {actionLabel && onAction && (
        <button className="btn-primary" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;

